import { ExamDayViewModel } from "../../model/ExamDayViewModel";
import { LocationViewModel } from "../../model/LocationViewModel";
import LocaleFormatDate from "../common/dates/LocaleFormatDate";
import { makeStyles } from "@material-ui/core";
import StepLabel from "@material-ui/core/StepLabel";
import Typography from "@material-ui/core/Typography";
import TodayIcon from "@material-ui/icons/Today";
import React, { FC } from "react";

const useStepStyles = makeStyles((theme) => ({
  root: {
    cursor: "pointer",
    color: "black",
  },
  active: {
    textDecoration: "underline",
  },
}));

interface SchedulerDayStepLabelProps {
  examDay: ExamDayViewModel;
  location?: LocationViewModel;
  isLocationVisible?: boolean;
  isStepActive: boolean;
}

interface IconProps {
  active: boolean;
}

const SchedulerStepIcon: FC<IconProps> = ({ active }) => {
  const classes = useStepStyles({});
  if (active) {
    return (
      <div className={`${classes.root} ${classes.active}`}>
        <TodayIcon />
      </div>
    );
  }

  return (
    <div className={classes.root}>
      <TodayIcon />
    </div>
  );
};

const SchedulerDayStepLabel: FC<SchedulerDayStepLabelProps> = ({
  examDay,
  location,
  isLocationVisible,
  isStepActive,
}) => {
  const classes = useStepStyles({});

  return (
    <StepLabel StepIconComponent={SchedulerStepIcon}>
      <Typography variant="h6" className={classes.root}>
        {isStepActive && <LocaleFormatDate className={classes.active} date={examDay.date} />}
        {!isStepActive && <LocaleFormatDate date={examDay.date} />}
        {isLocationVisible && location && <div>{location.name}</div>}
      </Typography>
      {isLocationVisible && location && (
        <React.Fragment>
          <Typography variant="subtitle2">{location.street}</Typography>
          <Typography variant="subtitle2">{`${location.zipCode} ${location.city}`}</Typography>
        </React.Fragment>
      )}
    </StepLabel>
  );
};

SchedulerDayStepLabel.defaultProps = {
  isLocationVisible: false,
} as Partial<SchedulerDayStepLabelProps>;

export default SchedulerDayStepLabel;
